"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceHelper = void 0;
var data_source_1 = require("devextreme/data/data_source");
var DataSourceHelper = (function () {
    function DataSourceHelper() {
    }
    DataSourceHelper.getDxDataSource = function (datasource) {
        if (datasource instanceof data_source_1.default)
            return datasource;
        return new data_source_1.default(datasource);
    };
    return DataSourceHelper;
}());
exports.DataSourceHelper = DataSourceHelper;
